import styled from 'styled-components';
import { Box, Button } from '@rsos/components/capstone/base';

export const HoveredButton = styled(Button).attrs(({ withIcon }) => ({
  btnType: 'invisible',
  size: 'xsmall',
  noMargin: true,
  width: withIcon ? '60px' : '40px',
  justify: 'space-evenly',
  align: 'center',
  height: 'inherit',
}))`
  color: ${p =>
    p.copied ? p.theme.colors.primaryBase : p.theme.colors.secondaryText};
`;

export const HoveredContainer = styled(Box).attrs(({ copied }) => ({
  bg: copied ? 'highlights' : 'foreground',

  display: copied ? 'flex' : 'none',
  height: 'inherit',
}))`
  border-radius: 5px;
  position: absolute;
  right: 0;
`;
